import { createSlice } from '@reduxjs/toolkit';
import {
  Item,
  UpSellData,
  Variant,
} from '../../../page-builder/interface/checkoutInterface';

export interface PreUpsellState {
  preUpsellData: UpSellData;
  preupsellLoading: boolean;
}

const initialVariant: Variant = {
  ID: '',
  ImageURL: '',
  OriginalPrice: '',
  Price: '',
  Title: '',
};

const initialItem: Item = {
  ID: '',
  ImageURL: '',
  Title: '',
  Variants: [initialVariant],
};

const initialState: PreUpsellState = {
  preUpsellData: [initialItem],
  preupsellLoading: false,
};

export const preUpsellSlice = createSlice({
  name: 'preUpsell',
  initialState,
  reducers: {
    setPreUpsellData(state, action) {
      return { ...state, preUpsellData: action.payload };
    },
    setPreUpsellLoading(state, action) {
      return { ...state, preupsellLoading: action.payload };
    },
  },
});

export const { setPreUpsellData, setPreUpsellLoading } = preUpsellSlice.actions;

export default preUpsellSlice.reducer;
